<template>
  <div class="list" name="add">
    <el-card style="margin-bottom:20px;padding-bottom:20px" shadow="never">
      <el-col>
        <el-form
                label-position="left"
                style="margin-top: 20px;"
                label-width="130px"
                :model="addForm"
                :rules="rule_data"
                ref="addForm">
          <el-form-item label="登录账号" prop="FAgentAccount">
            <el-input v-model="addForm.FAgentAccount" clear style="width:30%;" placeholder="8-20位数字或字母"></el-input>
            <auth-button
                    opt="check_agent"
                    icon="el-icon-search"
                    class="check"
                    @click.native="checkSubAg"
                    :loading="checkLoading"
                    label="检测"></auth-button>
          </el-form-item>
          <el-form-item label="登录密码" prop="FAgentPassword">
            <el-input v-model="addForm.FAgentPassword" type="password" clear style="width:30%;" placeholder="8-20位大写/小写字母/数字/符号中的至少三种组合"></el-input>
          </el-form-item>
          <el-form-item label="业务员姓名" prop="FName">
            <el-input v-model="addForm.FName" clear style="width:30%;"></el-input>
          </el-form-item>
          <el-form-item label="业务员手机" prop="FMobile">
            <el-input v-model="addForm.FMobile" clear style="width:30%;"></el-input>
          </el-form-item>
        </el-form>
        <el-button icon="el-icon-circle-plus-outline" @click="addSubmit('addForm')" type="primary" :loading="addLoading">提交</el-button>
      </el-col>
    </el-card>
  </div>
</template>

<script>
import qs from 'qs'
import md5 from 'js-md5'
// export default {AddJs};
import { checkSubAg, addSales } from '@/api/partner'
import { validStrictPsd, strictPsdError } from '@/utils/validate.js'

export default {
  data () {
    return {
      rule_data: {
        FAgentAccount: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('账号不能空'))
            } else {
              if (/^[a-zA-Z0-9]{8,20}$/.test(value)) {
                callback()
              } else {
                callback(new Error('请输入正确的账号格式'))
              }
            }
          },
          required: true,
          trigger: 'blur'
        }],
        FAgentPassword: [{
          validator: (rule, value, callback) => {
            if (validStrictPsd(value)) {
              callback()
            } else {
              return callback(new Error(strictPsdError))
            }
          },
          required: true,
          trigger: 'blur'
        }],
        FName: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入真实姓名'))
            } else {
              if (/^[\u4e00-\u9fa5]{2,6}$/.test(value)) {
                callback()
              } else {
                callback(new Error('请输入2-6位中文姓名'))
              }
            }
          },
          required: true,
          trigger: 'blur'
        }],
        FMobile: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入手机号码'))
            } else {
              if (!(/^\d{11,11}$/.test(value))) {
                callback(new Error('请输入11位手机号码'))
              } else {
                callback()
              }
            }
          },
          required: false
        }]
      },
      // 新增界面数据
      addForm: {
        FAgentAccount: '',
        FAgentPassword: '',
        FName: '',
        FMobile: ''
      },
      checkLoading: false,
      addLoading: false
    }
  },
  methods: {
    // 检测账号可用性
    checkSubAg () {
      var FAgent = this.addForm.FAgentAccount
      FAgent = { FAgentAccount: FAgent }
      FAgent = qs.stringify(FAgent)
      this.checkLoading = true
      checkSubAg(FAgent).then(data => {
        this.checkLoading = false
        if (parseInt(data.error_code) === 0) {
          this.$message({
            message: data.error_msg,
            type: 'success'
          })
        } else {
          this.$message({
            message: data.error_msg,
            type: 'warning'
          })
        }
      })
    },
    // 新增业务员
    addSubmit (addForm) {
      var that = this
      var pw = this.addForm.FAgentPassword
      // this.$refs[addForm].validate((valid) => {
      // if (valid) {
      this.$confirm('确认提交吗？', '提示', {}).then(() => {
        this.addLoading = true
        let para = Object.assign({}, this.addForm)
        para = JSON.parse(JSON.stringify(para))
        if (pw) { para.password = md5(pw) }
        para = qs.stringify(para)
        addSales(para).then(data => {
          this.addLoading = false
          if (parseInt(data.error_code) === 0) {
            this.$message({
              message: data.error_msg,
              type: 'success'
            })
            that.$refs.addForm.resetFields()
          } else {
            this.$message({
              showClose: true,
              message: data.error_msg,
              type: 'error'
            })
            that.$refs.addForm.resetFields()
          }
        }).catch(() => {
          that.$refs.addForm.resetFields()
        })
      })
      // }
      // });
    }
  }
  // ,
  // mounted() {
  //   this.addSubmit();
  // },
  // watch: {
  //   $route(to, from){
  //     this.addSubmit();
  //   }
  // }
}

</script>
<style rel="stylesheet/scss" lang="scss">
  .demo-form-inline {
    display: inline-block;
    float: right;
  }

  .btm-action {
    margin-top: 20px;
    text-align: center;
  }

  .pagination {
    display: inline-block;
  }
  .list{
    padding-left: 16px;
  }
  .tab-tag{
    height:0;
    padding: 0;
    line-height: 0;
    background: transparent;
  }
  .dsn{
    display: none;
  }
  .check{
    margin-left: 2%;
  }

</style>
